import require from '../utils/request'
export const economyIndexList = (params: {}) => require({
  url: '/blackcat/linkinfo/economic/detail',
  method: 'get',
  params
})
